import NewAuthLayout from "components/Layout/newAuth/AuthLayout"
import NewAuthLogin from "components/page_components/auth/User/Login/newAuthLogin"
import { useLang } from "hooks/useLang"
import { NextSeo } from "next-seo"

export default function LoginPage() {
    const { isAr } = useLang()

    return (
        <>
            <NextSeo
                title={isAr ? "تسجيل الدخول" : "Login"}
                description={
                    isAr
                        ? "تسجيل الدخول إلى حسابك في باس تيكيتس"
                        : "Login to your account in PassTickets"
                }
                noindex
                nofollow
                openGraph={{
                    title: isAr ? "تسجيل الدخول" : "Login",
                    description: isAr
                        ? "تسجيل الدخول إلى حسابك في باس تيكيتس"
                        : "Login to your account in PassTickets",
                    url: "https://pass-tickets.com/user/login",
                }}
            />
            <NewAuthLayout>
                <NewAuthLogin />
            </NewAuthLayout>
        </>
    )
}
